// Init slick slider
$('.exhibition-cards-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  centerMode: false,
  variableWidth: true,
  infinite: false,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
